<template>
  <div class="revision__container">
    <div class="warning__container">
      <div class="warning__title">
        <feather-icon
          class="mr-2"
          icon="AlertCircleIcon"
          svgClasses="stroke-current w-36.96 h-36.96"
        />
        <span> Revise suas Informações. </span>
      </div>
      <p class="warning__description">
        Antes de finalizar a sua candidatura, verifique se todos os dados estão
        devidamente preenchidos e
        <vs-button type="flat" @click="handleForward">
          clique aqui para confirmar a candidatura.
        </vs-button>
      </p>
    </div>
    <SimpleBasicInfo />
    <SimpleDiversity />
    <SimpleCurriculumn :not-filled="emptyCurriculumn && reviewing" />
    <SimpleAddress />
    <SimpleFormation :not-filled="formationsIsEmpty && reviewing" />
    <SimpleExperience :not-filled="experiencesIsEmpty && reviewing" />
    <SimpleLanguages />
    <SimpleSkill />
    <div class="flex flex-wrap mt-2">
      <backward-button @click="handleBackward" />
      <forward-button @click="handleForward" />
    </div>
    <vs-popup title="" :active.sync="alert">
      <div class="popup-container">
        <h2>
          Ops! Parece que você não preencheu nenhuma informação profissional.
        </h2>
        <div class="popup-container--image">
          <img
            src="@/assets/images/undraw_fitting_piece_re_pxay 1.svg"
            alt="Mulher negra mexendo em objetos abstratos."
          />
        </div>
        <p>
          Para completar seu perfil, <b>envie um cv</b> ou
          <b>preencha suas experiências profissionais</b>. Isso aumenta as suas
          chances de ser selecionado para a vaga.
        </p>
        <div class="popup-container--actions">
          <vs-button @click="handleReview">Completar meu Perfil</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SimpleBasicInfo from "../resumes/simple/modules/SimpleBasicInfo";
import SimpleDiversity from "../resumes/simple/modules/SimpleDiversity";
import SimpleCurriculumn from "../resumes/simple/modules/SimpleCurriculumn";
import SimpleAddress from "../resumes/simple/modules/SimpleAddress";
import SimpleFormation from "../resumes/simple/modules/SimpleFormation";
import SimpleExperience from "../resumes/simple/modules/SimpleExperience";
import SimpleLanguages from "../resumes/simple/modules/SimpleLanguages";
import SimpleSkill from "../resumes/simple/modules/SimpleSkill";
import BackwardButton from "@/components/BackwardButton";
import ForwardButton from "@/components/ForwardButton";

export default {
  created() {
    window.scroll(0, 0);

    this.fetchForms();
    this.googleAnalytics();
  },
  components: {
    SimpleBasicInfo,
    SimpleDiversity,
    SimpleCurriculumn,
    SimpleAddress,
    SimpleFormation,
    SimpleExperience,
    SimpleLanguages,
    SimpleSkill,
    BackwardButton,
    ForwardButton,
  },
  data: () => ({
    isForms: false,
    step_id: "",
    alert: false,
    reviewing: false,
  }),
  computed: {
    ...mapGetters("formation", ["formationsIsEmpty"]),
    ...mapGetters("experience", ["experiencesIsEmpty", "unskilled"]),
    ...mapGetters("basicInfo", ["emptyCurriculumn"]),
  },
  methods: {
    async fetchForms() {
      try {
        const { vacancy_id } = this.$router.history.current.params;

        if (vacancy_id) {
          const response = await this.$http.get(
            `/api/v1/questions/steps/vacancies/${vacancy_id}/exists`
          );

          this.isForms = response.data.data.step_id ? true : false;
          this.step_id = response.data.data.step_id;
        }
      } catch (error) {
        this.isForms = false;
      }
    },
    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/revision`)
        : this.$ga.page(`${company_label}/step/revision`);
    },

    handleBackward() {
      this.$store.dispatch("step/decrementCurrentStep");
      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params,
      });
    },

    async handleForward() {
      if (this.isForms) {
        const { params } = this.$router.history.current;

        this.$router.push({
          name: "application-process",
          params: { ...params, step_id: this.step_id },
        });
        return;
      }

      if (
        this.emptyCurriculumn &&
        this.experiencesIsEmpty &&
        !this.unskilled &&
        this.formationsIsEmpty
      ) {
        this.alert = true;
      } else {
        this.$router.push({
          name: "successfull-application",
        });
      }
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    handleReview() {
      this.alert = false;
      this.reviewing = true;

      const element = document.getElementsByClassName("revision__container");
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },
  },
};
</script>

<style lang="scss">
.revision__container {
  overflow-x: scroll;
}
.warning__container {
  padding: 8px;
  background-color: #ff9f43;
  border-radius: 2px;
  margin-bottom: 16px;

  color: #191919;
}
.warning__title {
  display: flex;
  align-items: center;
  font-weight: 600;
}
.warning__description {
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;

  button {
    padding: 0 !important;
    color: #0000ff !important;
    font-weight: 600 !important;
  }
}

.vs-popup--header {
  background: #fff;
}

.popup-container {
  width: 100%;

  h2 {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 23px;
    color: #172b4d;
  }

  p {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #172b4d;
  }

  &--image {
    margin: 20px 0;
    display: flex;
    text-align: center;
    justify-content: center;

    img {
      width: 281px;
      height: 288px;
    }
  }

  &--actions {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
